import React, { FunctionComponent } from 'react'

import { useWindowDimensions } from '../../Common/Hooks/useWindowDimensions'

import { IProps } from './IProps'
import {
  PersonHeadersWrapper,
  PersonHeader,
  PersonHeaderAvatar,
  PersonHeaderText,
  PersonHeadersContainer,
} from './style'

export const PersonHeaders: FunctionComponent<IProps> = ({
  filteredPersons,
  amountOfDays,
}) => {
  const { windowWidth } = useWindowDimensions()
  return (
    <PersonHeadersWrapper>
      {filteredPersons.map((person, index) => (
        <PersonHeadersContainer
          key={`personHeader${person.id}`}
          cabin={!!person.isCabin}
        >
          <PersonHeaderAvatar
            src={`${person.avatar}&w=25&h=25&fit=crop`}
            amountOfDays={amountOfDays}
            windowWidth={windowWidth}
            persons={filteredPersons.length}
          />
          <PersonHeader
            amountOfDays={amountOfDays}
            windowWidth={windowWidth}
            persons={filteredPersons.length}
            isBorder={filteredPersons.length !== index + 1}
          >
            <PersonHeaderText
              windowWidth={windowWidth}
              persons={filteredPersons.length}
            >
              {person.firstName}
            </PersonHeaderText>
          </PersonHeader>
        </PersonHeadersContainer>
      ))}
    </PersonHeadersWrapper>
  )
}
